/** Mensagem do comprador quando não dá para saber o gateway antes de tokenizar. */
export const FINANCE_UNAVAILABLE_MESSAGE =
	'Não conseguimos carregar o pagamento agora. Nada foi cobrado — aguarde alguns segundos e tente de novo.';

/**
 * Parâmetros financeiros da plataforma ANTES de tokenizar o cartão. O token
 * só vale no gateway que o emitiu, e o tokenizador escolhe o gateway por
 * `gateway`. Se o `/applications/params` falhou ao carregar a página (pay
 * instável, rede), não há gateway e a heurística antiga mandava o cartão para
 * a Pagar.me — numa plataforma Malga a compra morria em "Não pudemos validar
 * o cartão". Aqui busca de novo e, sem resposta, para: melhor um erro claro
 * sem nada cobrado do que tokenizar no gateway errado.
 */
export const resolveFinance = async <T>(
	loaded: T | undefined | null,
	fetchParams: () => Promise<T>,
	onError?: (error: unknown) => void
): Promise<T> => {
	if (loaded) return loaded;
	try {
		return await fetchParams();
	} catch (error) {
		onError?.(error);
		throw new Error(FINANCE_UNAVAILABLE_MESSAGE);
	}
};
